import * as types from '../constants/idpAdminActions';
import {logoutApi, RESULT} from "../api/api";
import {clearStorage} from "./storage";

export const logoutStart = () => ({
  type: types.LOGOUT_START
});
export const logoutSuccess = () => ({
  type: types.LOGOUT_SUCCESS
});
export const logoutFail = (errorMsg) => ({
  type: types.LOGOUT_FAIL,
  errorMsg,
});

// 404 means the session no longer exists, which is the outcome logout wants.
const isLoggedOut = (result) => result.kind !== RESULT.FAILED || result.status === 404;

export function logout() {
  return dispatch => {
    dispatch(logoutStart());
    return logoutApi()
    .then(result => {
      clearStorage();
      if (isLoggedOut(result)) {
        dispatch(logoutSuccess());
      } else {
        dispatch(logoutFail(result.code || result.reason));
      }
    })
  }
}
